import React, { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FiltroMultiple from "../../Postventa/Dashboard/Modales/FiltroMultiple";

export const TablaPowergard = ({
  info,
  onAgregar,
  onEliminar,
  permisoEliminar,
}) => {
  //Filtros
  const [options, setOptions] = useState({
    sucursal: [],
    vendedor: [],
    cobertura: [],
    contrato: [],
  });
  const [filtros, setFiltros] = useState({
    sucursal: [],
    vendedor: [],
    cobertura: [],
    contrato: [],
  });
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [filtrosTemp, setFiltrosTemp] = useState({
    sucursal: [],
    vendedor: [],
    cobertura: [],
    contrato: [],
  });

  const [mostrarFiltro, setMostrarFiltro] = useState({
    sucursal: false,
    vendedor: false,
    cobertura: false,
    contrato: false,
  });

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);

      let nuevasPrioridades;

      // nuevo filtro → se agrega
      if (index === -1) {
        nuevasPrioridades = [...prev, filtro];
      }
      // filtro existente → se cortan los posteriores
      else {
        nuevasPrioridades = prev.slice(0, index + 1);
      }

      // 🔥 LIMPIAR filtros que perdieron prioridad
      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      // 🔥 LIMPIAR filtros aplicados también
      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
    let resultado = [...data];

    filtrosPermitidos.forEach((filtro) => {
      if (filtro === "sucursal" && filtros.sucursal.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.sucursal.includes(i.sucursal),
        );
      }

      if (filtro === "vendedor" && filtros.vendedor.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.vendedor.includes(i.vendedor),
        );
      }

      if (filtro === "cobertura" && filtros.cobertura.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.cobertura.includes(i.cobertura),
        );
      }

      if (filtro === "contrato" && filtros.contrato.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.contrato.includes(i.contrato === "C" ? "C" : "P"),
        );
      }
    });

    return resultado;
  };

  //Actualizacion de datos dependiendo filtros
  useEffect(() => {
    if (!Array.isArray(info)) return;

    let data = [...info];
    console.log(info);
    prioridadFiltros.forEach((filtro) => {
      switch (filtro) {
        case "sucursal":
          if (filtros.sucursal.length > 0) {
            data = data.filter((i) => filtros.sucursal.includes(i.sucursal));
          }
          break;

        case "vendedor":
          if (filtros.vendedor.length > 0) {
            data = data.filter((i) => filtros.vendedor.includes(i.vendedor));
          }
          break;

        case "cobertura":
          if (filtros.cobertura.length > 0) {
            data = data.filter((i) => filtros.cobertura.includes(i.cobertura));
          }
          break;

        case "contrato":
          if (filtros.contrato.length > 0) {
            data = data.filter((i) =>
              filtros.contrato.includes(i.contrato === "C" ? "C" : "P"),
            );
          }
          break;

        default:
          break;
      }
    });

    setDatosFiltrados(data);
  }, [info, filtros, prioridadFiltros]);

  //Esquema de filtrado en tabla
  useEffect(() => {
    if (!Array.isArray(info)) return;

    const getBaseData = (filtro) => {
      const index = prioridadFiltros.indexOf(filtro);

      // Si el filtro NO ha sido usado aún → usar data filtrada actual
      if (index === -1) {
        return aplicarFiltros(info, filtros, null, prioridadFiltros);
      }

      // Si es el primero → data completa
      if (index === 0) {
        return info;
      }

      // Solo aplicar filtros con MAYOR prioridad
      const filtrosPrevios = prioridadFiltros.slice(0, index);

      return aplicarFiltros(info, filtros, null, filtrosPrevios);
    };

    // SUCURSAL
    const sucursalOptions = [
      ...new Set(getBaseData("sucursal").map((i) => i.sucursal)),
    ].map((v) => ({ value: v, label: v }));

    // VENDEDOR
    const vendedorOptions = [
      ...new Set(getBaseData("vendedor").map((i) => i.vendedor)),
    ].map((v) => ({ value: v, label: v }));

    // COBERTURA
    const coberturaOptions = [
      ...new Set(getBaseData("cobertura").map((i) => i.cobertura)),
    ].map((v) => ({ value: v, label: v }));

    // Contrato
    const contratoOptions = [
      ...new Set(getBaseData("contrato").map((i) => i.contrato)),
    ].map((v) => ({
      value: v,
      label: v === "P" ? "Pendiente" : v === "C" ? "Comprado" : "Desconocido",
    }));

    setOptions({
      sucursal: sucursalOptions,
      vendedor: vendedorOptions,
      cobertura: coberturaOptions,
      contrato: contratoOptions,
    });
  }, [info, filtros, prioridadFiltros]);

  return (
    <div className="paquete-servicio-powergard-tabla scroll">
      <table cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>Cliente</th>
            <th>
              <FiltroMultiple
                label="Sucursal"
                field="sucursal"
                options={options.sucursal}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
              />
            </th>
            <th>
              <div>Serie</div>
            </th>
            <th>
              <div>Facturacion</div>
            </th>
            <th>
              <div>Costo</div>
            </th>
            <th>
              <div>Interna/Externa</div>
            </th>
            <th>
              <div>Fecha Facturacion</div>
            </th>
            <th>
              <div>OT</div>
            </th>
            <th>
              <FiltroMultiple
                label="Vendedor"
                field="vendedor"
                options={options.vendedor}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
              />
            </th>
            <th>
              <FiltroMultiple
                label="Cobertura"
                field="cobertura"
                options={options.cobertura}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
              />
            </th>
            <th>
              <FiltroMultiple
                label="Contrato"
                field="contrato"
                options={options.contrato}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
              />
            </th>
            {permisoEliminar && (
              <th>
                <div>Editar</div>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {datosFiltrados.map((item, index) => {
            // Calcula la suma de la fila
            // const total = [
            //     item.enero,
            //     item.febrero,
            //     item.marzo,
            //     item.abril,
            //     item.mayo,
            //     item.junio,
            //     item.julio,
            //     item.agosto,
            //     item.septiembre,
            //     item.octubre,
            //     item.noviembre,
            //     item.diciembre
            // ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0); // Asegura que se sumen solo números

            return (
              <tr key={index}>
                <td>{item.cliente}</td>
                <td className="columna-centrada">{item.sucursal}</td>
                <td className="columna-centrada">{item.serie}</td>
                <td>{FormatMoney(item.facturacion)}</td>
                <td className="columna-centrada">{FormatMoney(item.costo)}</td>
                <td>{item.tipo === "I" ? "Interna" : "Externa"}</td>
                <td className="columna-centrada">
                  {item.fecha_facturacion ? item.fecha_facturacion : ""}
                </td>
                <td>{item.num_ot}</td>
                <td className="columna-centrada">{item.vendedor}</td>
                <td>{item.cobertura}</td>
                <td>
                  {item.contrato === "P"
                    ? "Pendiente"
                    : item.contrato === "C"
                      ? "Comprado"
                      : "Sin contrato"}
                </td>
                {permisoEliminar && (
                  <td className="columna-centrada">
                    <div className="container-botones">
                      <div
                        className="boton-editar"
                        onClick={() => onAgregar(item.idpowergard)}
                      >
                        <EditIcon />
                      </div>
                      <div
                        className="boton-eliminar"
                        onClick={() =>
                          onEliminar(item.idpowergard, "powergard")
                        }
                      >
                        <DeleteIcon />
                      </div>
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
          {/* <tr>
                                <td colSpan={2} className='columna-derecha total'>TOTALES: </td>
                                {['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'].map((mes) => {
                                    const totalMes = data.reduce((acc, item) => acc + (parseFloat(item[mes]) || 0), 0);
                                    return <td key={mes} className='columna-centrada total'>{FormatMoney(totalMes)}</td>;
                                })}
                                <td className='columna-centrada total'>
                                    {data.reduce((acc, item) => acc + (parseFloat(item.enero) || 0) + (parseFloat(item.febrero) || 0) + (parseFloat(item.marzo) || 0) + (parseFloat(item.abril) || 0) + (parseFloat(item.mayo) || 0) + (parseFloat(item.junio) || 0) + (parseFloat(item.julio) || 0) + (parseFloat(item.agosto) || 0) + (parseFloat(item.septiembre) || 0) + (parseFloat(item.octubre) || 0) + (parseFloat(item.noviembre) || 0) + (parseFloat(item.diciembre) || 0), 0)}
                                </td>
                            </tr> */}
        </tbody>
      </table>
    </div>
  );
};
